import type { PresetPassThroughOptions } from '../preset-options'

/** Base input styling – matches input-wrapper styles */
export default {
  inputtext: {
    root: ({ props }: PresetPassThroughOptions) => ({
      class: [
        'relative inline-flex',
        'w-full',
        {
          'opacity-60 select-none pointer-events-none cursor-default':
            props?.disabled,
        },
      ],
    }),
    input: {
      class: [
        'w-full',
        'py-3',
        'px-3',
        'text-fp-gray-6',
        'bg-white',
        'border border-fp-gray-3',
        'rounded-md',
        'focus:ring-2 focus:ring-primary focus:ring-offset-0',
        'focus:border-primary',
        'focus:outline-none',
        'disabled:opacity-50',
        'disabled:bg-fp-gray-1',
        'disabled:cursor-not-allowed',
        'transition-colors duration-200',
      ],
    },
  },
}
